<template>
  <v-card outlined class="mt-0 mb-0" style="border: 0">
    <v-row>
      <v-col cols="4" class="pa-3 pt-2 pb-2">
        <v-list-item-title class="display-1 mb-1 text-center">% Hoàn thành KPI</v-list-item-title>
        <v-card-text class="text-center success--text mt-2" style="font-size: 14px">
          {{ _.get(this.report, 'kpi', 0) + '%' }}
        </v-card-text>
      </v-col>

      <v-col cols="4" class="pt-2 pb-2">
        <v-list-item-title class="display-1 mb-1 text-center">Doanh thu thành công</v-list-item-title>
        <v-card-text class="text-center mt-2" style="font-size: 14px">
          {{formatPrice(_.get(this.report, 'successTurnOver', 0))}} VNĐ
        </v-card-text>
      </v-col>

      <v-col cols="4" class="pt-2 pb-2">
        <v-list-item-title class="display-1 mb-1 text-center">Tỉ lệ chốt</v-list-item-title>
        <v-card-text class="text-center mt-2 teal--text" style="font-size: 14px">
          {{ _.get(this.report, 'successLatchRatio', 0) + '%' }}
        </v-card-text>
      </v-col>
    </v-row>
  </v-card>
</template>

<script>
import * as moment from 'moment'
import TokenService from '../../../helpers/token';
import RepositoryFactory from '../../../repositories/RepositoryFactory';
const ReportRepository = RepositoryFactory.get('report');

export default {
  data() {
    return {
      dataUser: TokenService.getUser() || {},
      report: {},
      userLatchRatio: 0
    };
  },
  created() {
    this.fetchDataUser()
  },
  methods: {
    async fetchDataUser() {
      const params = {
    	userId: this.dataUser.id,
    	startDate: moment().startOf('month').format('YYYY-MM-DD'),
    	endDate: moment().endOf('month').format('YYYY-MM-DD'),
    	duration: 'month'
	  };
      this.loading = this.$loading.show();
      const response = await ReportRepository.personalReport(params);
      this.loading.hide();

      if (response.error) {
        this.errorMessage = _.get(response, 'message', '');
        return;
      } else {
        const report = _.get(response, 'data', {});
        this.report =  {
          ...report,
          userLatchRatio: Number(_.get(report, 'userLatchRatio', 0)),
          kpi: Number(_.get(report, 'kpi', 0)),
        }
      }
    }
  }
}
</script>
